const removeIdsFromCustomCodeSnippets = (snippets) =>
  snippets.map(({ id, ...restData }) => restData);

export default removeIdsFromCustomCodeSnippets;
